import { render, staticRenderFns } from "./PanelMain.vue?vue&type=template&id=2514122a&scoped=true&"
import script from "./PanelMain.vue?vue&type=script&lang=js&"
export * from "./PanelMain.vue?vue&type=script&lang=js&"
import style0 from "./PanelMain.vue?vue&type=style&index=0&id=2514122a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2514122a",
  null
  
)

export default component.exports